import React, { useState, useEffect } from 'react';
import Sidebar from '../components/sidebar';
import { Card, Row, Col, Button, Typography } from 'antd';
import { UserOutlined, VideoCameraOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import './SeleccionTipoCampana.css';

const { Title, Text } = Typography;

const url = "https://api.mrcirp.com/public/usuarios";
const urlCampanasAudiencia = "https://api.mrcirp.com/public/campanas-audiencia";

const SeleccionTipoCampana = () => {
  const navigate = useNavigate();
  
  // Datos de Usuario Logueado
  const [users, setUsers] = useState([]);
  const [campanasActivas, setCampanasActivas] = useState(0);

  useEffect(() => {
    const loginUserJSON = window.localStorage.getItem("loginUser");
    if (loginUserJSON) {
      const user = JSON.parse(loginUserJSON);
      setUsers(user);
      
      // Cargar datos completos del usuario desde el endpoint para obtener codigo_membresia y membresia
      if (user.id) {
        axios.get(`https://api.mrcirp.com/public/userpanel/${user.id}`)
          .then((response) => {
            if (response.data && response.data[0]) {
              const userData = response.data[0];
              setUsers(prevUser => ({
                ...prevUser,
                ...userData
              }));
              
              // Cargar campañas activas
              cargarCampanasActivas(user.id, userData);
            }
          })
          .catch((error) => {
            console.error('Error cargando datos del usuario:', error);
          });
      }
    }
  }, []);

  const cargarCampanasActivas = async (userId, userData) => {
    try {
      // Obtener campañas de video (usuarios)
      const responseVideo = await axios.get(url);
      const filteredVideoData = responseVideo.data.filter(item => 
        item.creador === userId && (item.activa === 1 || item.activa === true)
      );
      
      // Obtener campañas de lanzamiento
      const responseAudiencia = await axios.get(urlCampanasAudiencia);
      const filteredAudienciaData = responseAudiencia.data.filter(item => 
        item.admin_id === userId && (item.activa === 1 || item.activa === true)
      );
      
      const totalActivas = filteredVideoData.length + filteredAudienciaData.length;
      setCampanasActivas(totalActivas);
    } catch (error) {
      console.error('Error al obtener campañas activas:', error);
    }
  };

  const tiposCampana = [
    {
      id: 'audiencia',
      nombre: 'Campaña de Lanzamiento',
      descripcion: 'Crea campañas de lanzamiento dirigidas a audiencias específicas para maximizar el alcance y engagement',
      icono: <UserOutlined />,
      color: '#1890ff',
      ruta: '/campana-audiencia'
    },
    {
      id: 'video',
      nombre: 'Campaña de Video',
      descripcion: 'Desarrolla campañas basadas en contenido de video para mayor impacto visual',
      icono: <VideoCameraOutlined />,
      color: '#52c41a',
      ruta: '/referidos'
    }
  ];

  // Calcular si el usuario ha alcanzado su límite
  const limites = {
    'Katana Demo': 1,
    'Katana Basic': 2,
    'Katana Pro': 5,
    'Katana Premium': 10
  };
  const limite = users.membresia ? (limites[users.membresia] || 0) : 0;
  const haAlcanzadoLimite = limite > 0 && campanasActivas >= limite;

  const handleSeleccionarTipo = (tipo) => {
    if (haAlcanzadoLimite) {
      alert(`Has alcanzado el límite de campañas para tu membresía (${users.membresia}).\n\nLímite: ${limite} campañas activas\nActualmente tienes: ${campanasActivas} campañas activas\n\nPor favor, desactiva alguna campaña existente o actualiza tu membresía para crear más campañas.`);
      return;
    }
    navigate(tipo.ruta);
  };

  return (
    <div>
      <Sidebar>
        <div className="seleccion-tipo-container">
          <div className="text-center mb-4">
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
              <div style={{ flex: 1 }}></div>
              <div style={{ flex: 1, textAlign: 'center' }}>
                <Title level={3} className="seleccion-tipo-title" style={{ margin: 0 }}>
                  🚀 Crear Nueva Campaña
                </Title>
              </div>
              <div style={{ flex: 1, display: 'flex', justifyContent: 'flex-end', gap: '16px' }}>
                {users.codigo_membresia && users.membresia && (
                  <>
                    <span style={{ 
                      fontSize: '1rem', 
                      fontWeight: '600', 
                      color: '#2d3748',
                      padding: '4px 12px',
                      backgroundColor: '#f7fafc',
                      borderRadius: '8px',
                      border: '1px solid #e2e8f0'
                    }}>
                      {users.codigo_membresia}
                    </span>
                    <span style={{ 
                      fontSize: '1rem', 
                      fontWeight: '600', 
                      color: '#2d3748',
                      padding: '4px 12px',
                      backgroundColor: '#f7fafc',
                      borderRadius: '8px',
                      border: '1px solid #e2e8f0'
                    }}>
                      {(() => {
                        const limites = {
                          'Katana Demo': 1,
                          'Katana Basic': 2,
                          'Katana Pro': 5,
                          'Katana Premium': 10
                        };
                        const limite = limites[users.membresia] || 0;
                        return `${campanasActivas}/${limite}`;
                      })()}
                    </span>
                  </>
                )}
              </div>
            </div>
            <Text className="seleccion-tipo-subtitle">
              Selecciona el tipo de campaña que deseas crear
            </Text>
          </div>

          <Row gutter={[24, 24]} justify="center">
            {tiposCampana.map((tipo) => (
              <Col xs={24} sm={12} lg={8} key={tipo.id}>
                <Card
                  className={`tipo-campana-card ${tipo.id}`}
                  hoverable={!haAlcanzadoLimite}
                  style={{ 
                    border: `2px solid ${haAlcanzadoLimite ? '#d9d9d9' : tipo.color}`,
                    borderRadius: '16px',
                    height: '100%',
                    cursor: haAlcanzadoLimite ? 'not-allowed' : 'pointer',
                    opacity: haAlcanzadoLimite ? 0.6 : 1
                  }}
                  onClick={() => !haAlcanzadoLimite && handleSeleccionarTipo(tipo)}
                >
                  <div className="text-center">
                    <div 
                      className="tipo-campana-icon"
                      style={{ color: tipo.color }}
                    >
                      {tipo.icono}
                    </div>
                    <Title level={4} style={{ color: tipo.color, margin: '16px 0 8px 0' }}>
                      {tipo.nombre}
                    </Title>
                    <Text className="tipo-campana-descripcion">
                      {tipo.descripcion}
                    </Text>
                  </div>

                  <div className="text-center mt-4">
                    <Button
                      type="primary"
                      size="large"
                      disabled={haAlcanzadoLimite}
                      style={{
                        backgroundColor: haAlcanzadoLimite ? '#d9d9d9' : tipo.color,
                        borderColor: haAlcanzadoLimite ? '#d9d9d9' : tipo.color,
                        borderRadius: '8px',
                        height: '48px',
                        fontSize: '16px',
                        fontWeight: 'bold',
                        minWidth: '200px',
                        cursor: haAlcanzadoLimite ? 'not-allowed' : 'pointer'
                      }}
                      onClick={(e) => {
                        e.stopPropagation();
                        handleSeleccionarTipo(tipo);
                      }}
                    >
                      {haAlcanzadoLimite ? 'Límite Alcanzado' : 'Seleccionar'}
                    </Button>
                  </div>
                </Card>
              </Col>
            ))}
          </Row>

          {haAlcanzadoLimite && (
            <div className="text-center mt-4">
              <Card 
                className="info-card"
                style={{
                  background: 'linear-gradient(135deg, #fff3cd 0%, #ffe69c 100%)',
                  border: '2px solid #ffc107'
                }}
              >
                <Title level={5} style={{ color: '#856404', marginBottom: '8px' }}>
                  ⚠️ Límite de Campañas Alcanzado
                </Title>
                <Text style={{ color: '#856404', display: 'block', marginBottom: '8px' }}>
                  Has alcanzado el límite de <strong>{limite} campañas activas</strong> para tu membresía <strong>{users.membresia}</strong>.
                </Text>
                <Text style={{ color: '#856404', display: 'block' }}>
                  Para crear más campañas, desactiva alguna campaña existente desde <strong>Mis Campañas</strong> o actualiza tu membresía.
                </Text>
              </Card>
            </div>
          )}

          {!haAlcanzadoLimite && (
            <div className="text-center mt-4">
              <Card className="info-card">
                <Title level={5}>💡 ¿No estás seguro?</Title>
                <Text>
                  Puedes cambiar el tipo de campaña en cualquier momento durante el proceso de creación.
                </Text>
              </Card>
            </div>
          )}
        </div>
      </Sidebar>
    </div>
  );
};

export default SeleccionTipoCampana;
